import CryptoJS from 'crypto-js';

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

// Encrypt function
export const encryptData = (data) => {
    return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
};

// Decrypt function
export const decryptData = (encryptedData) => {
    try {
        const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch (error) {
        return null;
    }
};

// Save encrypted data to localStorage
export const saveSecureData = (key, data) => {
    localStorage.setItem(key, encryptData(data));
};

// Retrieve and decrypt data from localStorage
export const getSecureData = (key) => {
    const encryptedData = localStorage.getItem(key);
    if (!encryptedData) return null;
    return decryptData(encryptedData);
};

// Remove data securely
export const removeSecureData = (key) => {
    localStorage.removeItem(key);
};
